import type {SortConfig, SortDirection, SortField} from '../runs/PredictionBatchTypes';
import type {PredictionJobSearchFilters} from './usePredictionJobSearch';
import {DEFAULT_FILTERS} from './usePredictionJobSearch';

const VALID_SORT_FIELDS: Set<string> = new Set(['createdAt', 'modifiedAt']);

export function readPredictionJobFiltersFromUrl(): PredictionJobSearchFilters {
  const params = new URLSearchParams(window.location.search);

  return {
    query: params.get('jobQ') ?? DEFAULT_FILTERS.query,
    predictionBatchId: params.get('predictionBatchId') || null,
  };
}

export function readPredictionJobSortFromUrl(): SortConfig {
  const params = new URLSearchParams(window.location.search);
  const sortParam = params.get('jobSort');
  if (sortParam) {
    const [field, dir] = sortParam.split(':');
    if (VALID_SORT_FIELDS.has(field)) {
      const direction: SortDirection = dir === 'asc' ? 'asc' : 'desc';
      return {key: field as SortField, direction};
    }
  }
  return {key: 'createdAt', direction: 'desc'};
}

export function writePredictionJobFiltersToUrl(filters: PredictionJobSearchFilters, sort: SortConfig): void {
  const url = new URL(window.location.href);
  const params = url.searchParams;

  if (filters.query) {
    params.set('jobQ', filters.query);
  } else {
    params.delete('jobQ');
  }

  if (filters.predictionBatchId) {
    params.set('predictionBatchId', filters.predictionBatchId);
  } else {
    params.delete('predictionBatchId');
  }

  params.set('jobSort', `${sort.key}:${sort.direction}`);

  window.history.replaceState(window.history.state, '', url.toString());
}

export function hasPredictionJobActiveFilters(filters: PredictionJobSearchFilters): boolean {
  return filters.query !== '' || Boolean(filters.predictionBatchId);
}
